<template>

	<!-- for header part -->
	<header> 

		<div class="logosec"> 
			<!--
			<img src="/assets/images/logo.png" class="logo"> -->
			<h5> <i class="bi bi-sun color-1"></i> <i class="bi bi-dot"></i> Weather </h5>
			<button class="btn btn-lg menuicn color-1" id="menuicn" @click="header()"> <i class="bi bi-grid-fill"></i> </button> 
		</div> 

		<div class="searchbar"> 
			<p class="text-secondary">Data last received at : <span>{{this.$store.state.data_last_received_at}}</span> <span v-if="!this.$store.state.data_last_received_at">Please wait...</span> </p>
		</div> 

		<div class="message"> 
			<div class="circle"></div>
			<div class="dp"> 

			</div> 

			{{ current_time }}
			 
		</div> 

	</header> 

	


</template>

<script>
	
	export default{
		name : 'header',

		data(){
			return{
				current_time : ''
			}
		},

		methods : {
			header(){
		let menuicn = document.querySelector(".menuicn"); 
let nav = document.querySelector(".navcontainer"); 
nav.classList.toggle("navclose"); 


			}
		},

		created(){

			setInterval((data)=>{
				this.current_time = new Date()
			},1000)
			
		}
	}

</script>